import { useQuery } from "@tanstack/react-query";
import { ActivityKeys } from "web_myplann/Api/Activities/ActivityKeys";
import { getDashboardEventsV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useEventsQuery = (
	filterDatefrom?: string,
	filterDateto?: string,
	filterOnlyunsolved?: boolean,
	filterOnlysolved?: boolean,
	limit?: number,
	offset?: number,
) => {
	return useQuery({
		queryKey: ActivityKeys.events(),
		queryFn: processResponse(() =>
			getDashboardEventsV2(
				filterDatefrom,
				filterDateto,
				filterOnlyunsolved,
				filterOnlysolved,
				limit,
				offset,
			),
		),
	});
};
